import { render, staticRenderFns } from "./Visualizador.vue?vue&type=template&id=3f13dd6c"
import script from "./Visualizador.vue?vue&type=script&lang=js"
export * from "./Visualizador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports